import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M34.4664 13.9244C32.5826 13.0186 29.7266 12.247 24.6512 14.3349C7.36204 21.4474 11.4184 36.3161 12.8154 40.9893C14.2123 45.6624 20.8688 51.6425 26.9637 52.7285C33.0587 53.8146 43.2036 51.7195 46.9211 45.857C49.8788 41.1927 49.9186 37.6892 49.6605 33.5423",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6569 19.5197C50.2393 20.7534 46.1759 26.287 42.0373 32.1594C38.5992 37.0378 36.673 40.0653 35.5103 41.9445C35.1836 42.4724 34.4623 42.5788 33.9654 42.2067C32.2952 40.9562 30.7017 40.2798 28.5436 38.5186C25.993 36.437 21.821 33.6877 21.6194 32.552C21.4177 31.4163 24.3669 28.0963 25.2691 28.2289C25.9198 28.3246 29.0949 30.4856 31.4835 32.0604C31.9098 32.3414 32.4716 32.2468 32.7621 31.827C33.9802 30.0672 36.4721 26.1276 37.7159 24.2325C39.1892 21.9876 44.0343 15.4459 45.856 14.4507C47.3133 13.6545 49.3935 14.9123 50.0189 15.3296C52.0963 16.7121 51.1987 16.1842 52.4958 16.8911C54.117 17.7747 53.0744 18.286 51.6569 19.5197Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6187 19.7884C50.4518 20.804 46.124 26.4135 43.0057 30.7261C39.8873 35.0388 37.9592 37.5999 34.2435 42.2838C32.1036 40.2315 27.8053 38.1811 25.7057 36.4676C23.6062 34.7541 19.9709 32.2514 19.8049 31.3166C19.6389 30.3817 24.3408 24.9947 25.0834 25.1039C25.6775 25.1913 30.1387 28.3452 32.1267 29.6372C32.9183 28.2635 35.6406 23.6156 36.8533 21.7677C38.0661 19.9198 42.8169 14.1758 44.3164 13.3566C45.516 12.7012 46.2978 13.4448 46.8126 13.7882C48.5226 14.9263 50.7184 16.7945 51.786 17.3764C53.1206 18.1038 52.7856 18.7729 51.6187 19.7884Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCheck;
